import { allFacilityAttributes } from 'constants/facilities'

export const getFacilityLabels = obj =>
  obj
    ? Object.keys(obj)
        .filter(attr => !!obj[attr])
        .map(attr => allFacilityAttributes.find(a => attr === a.key))
        .map(match => (match ? match.label : ''))
        .join(' \u00b7 ')
    : ''
